import { render, staticRenderFns } from "./NewsItemBN.vue?vue&type=template&id=5675e068&scoped=true&"
import script from "./NewsItemBN.vue?vue&type=script&lang=ts&"
export * from "./NewsItemBN.vue?vue&type=script&lang=ts&"
import style0 from "./NewsItemBN.vue?vue&type=style&index=0&id=5675e068&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675e068",
  null
  
)

export default component.exports